/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{getPlacementOperator as t}from"../CIMOperators.js";class e{static getPlacement(e,r,n,s,c,o){const a=t(n);if(!a)return null;-1===r&&e.invertY();return a.execute(e,n,s,c,o)}}export{e as CIMMarkerPlacementHelper};
